import { useEffect, useState } from "react";

/**
 * Bar under the crosshair of the chart engine, from engine.events.onCrosshairMove,
 * without requests. Moving the pointer within one bar does not re-render.
 *
 * @param {object|null} engine - ChartEngine from useChartEngine
 * @returns {{ bar: object, decimals: number } | null} null when the crosshair is hidden
 *   or over the empty space right of the last bar; decimals: price precision of the pair
 */
const useCrosshairBar = (engine) => {
  const [crosshairBar, setCrosshairBar] = useState(null);

  useEffect(() => {
    if (!engine) return undefined;

    const unsubscribe = engine.events.onCrosshairMove((crosshair) => {
      const bar = crosshair?.bar || null;
      const decimals = crosshair?.decimals;

      setCrosshairBar((previous) => {
        if (!bar) return null;
        if (previous?.bar === bar && previous.decimals === decimals) return previous;

        return { bar, decimals };
      });
    });

    return () => {
      unsubscribe();
      setCrosshairBar(null);
    };
  }, [engine]);

  return crosshairBar;
};

export default useCrosshairBar;
